<script>
// You can add any necessary logic or data here
</script>

<div class="header">
        <h1>Natalia Lysy</h1>
</div>

<style>
    /* Add styling for the header and buttons */

    .header h1 {
        color: #0b303b;
        font-size: 5em;
        padding: 0 40px;
    }

    .header {
        border-radius: 20px;
        background-color: #fef4ee;
        color: #0b303b;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
    }

</style>
